import Process from './process';

const process = new Process();

export default process;
